module.exports = __webpack_public_path__ + "static/img/gzhQRCode.742ac25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzhQRCode.png
// module id = Oii1
// module chunks = 0